import { render, staticRenderFns } from "./CommentsPanel.vue?vue&type=template&id=a8c06692&scoped=true"
import script from "./CommentsPanel.vue?vue&type=script&lang=js"
export * from "./CommentsPanel.vue?vue&type=script&lang=js"
import style0 from "./CommentsPanel.vue?vue&type=style&index=0&id=a8c06692&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c06692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c06692')) {
      api.createRecord('a8c06692', component.options)
    } else {
      api.reload('a8c06692', component.options)
    }
    module.hot.accept("./CommentsPanel.vue?vue&type=template&id=a8c06692&scoped=true", function () {
      api.rerender('a8c06692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/CommentsPanel.vue"
export default component.exports